import React, { useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import request from '../../../util/SuperagentUtils';
import Busy from '../../Busy';
import { blogEndpoints } from '../../../requests/api-endpoints';
import {
    SubscribeButton,
    SubscribeContainer,
    SubscribeIcon,
    SubscribeTitle,
    MessageText,
    SuccessText,
} from './styles';

export interface SubscribeEmailProps {
    email: string;
    setEmail: (email: string) => void;
}

const SubscribeEmail = ({ email, setEmail }: SubscribeEmailProps) => {
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');

    function validateEmail(emailToValidate: string): boolean {
        const re = /\S+@\S+\.\S+/;
        return re.test(emailToValidate);
    }

    const handleSubscribe = async (): Promise<void> => {
        setSuccessMessage('');
        if (!email) return setErrorMessage('Please enter your email address');
        if (!validateEmail(email)) return setErrorMessage('Please enter a valid email address');
        Busy.set(true);
        setErrorMessage('');
        try {
            await request.post(blogEndpoints.subscribe).send({
                email: email.toLowerCase(),
            });
            setEmail('');
            setErrorMessage('');
            setSuccessMessage('Thank you for subscribing to our blog!');
        } catch (error: unknown) {
            const apiError = error as { response?: { body?: { message?: string } } };
            const errMsg = apiError?.response?.body?.message || 'Something went wrong, please try again later!';
            setErrorMessage(errMsg);
        }
        finally {
            Busy.set(false);
        }
    };

    return (
        <SubscribeContainer>
            <SubscribeTitle>Subscribe to our blog</SubscribeTitle>
            <TextField
                type='email'
                InputLabelProps={{ shrink: true }}
                value={email}
                onChange={(e) => { setEmail(e.target.value); }}
                placeholder='yourmail@example.com'
                className='ss-blog-sub-input'
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <SubscribeIcon
                                src="https://static.secur.space/icons/subemail.png"
                                alt="Subscribe icon"
                            />
                        </InputAdornment>
                    ),
                }}
                fullWidth
                label="Email"
                variant="standard"
            />
            {errorMessage && !successMessage && (
                <MessageText variant='subtitle2' color='error'>
                    {errorMessage}
                </MessageText>
            )}
            {!errorMessage && successMessage && (
                <SuccessText variant='subtitle2'>
                    {successMessage}
                </SuccessText>
            )}
            <SubscribeButton onClick={handleSubscribe} fullWidth>
                SUBSCRIBE
            </SubscribeButton>
        </SubscribeContainer>
    );
};

export default SubscribeEmail;

